import AboutItem from "../AboutItem";
import PrimaryAnchorBtn from "../../../../common/Anchors/PrimaryAnchorBtn";
import redSemiCircle from "../../../../../assets/img/icons/shapes/redSemiCircle.svg";
import FutureProofItThumbnail from "../../../../../assets/img/other/MultipleMethods.webp";

export default function FutureProofIt() {
    return (
        <AboutItem
            heading="Your equipment information, connected."
            thumbnail={FutureProofItThumbnail}
            floatingIcon={
                <div className="zindex-3 d-none d-lg-block position-absolute top-0 start-50 translate-middle w-auto ms-2">
                    <div data-aos="fade-up" data-aos-duration="950" data-aos-offset="280" className="aos-init aos-animate">
                        <img src={redSemiCircle} alt="Circle Icon" width="108px" />
                    </div>
                </div>
            }
        >

            <div className="about-copy">
                <p>
                    Bring equipment, jobs, maintenance, parts and stock into one cloud-based system. Keep records together so your team can check what's assigned, what's available and what needs attention.
                </p>
                <p>
                    Use your phone or tablet to scan QR codes, view records and make updates. Less time searching through spreadsheets and paperwork means more time to get on with the job.
                </p>
                <PrimaryAnchorBtn title="Book a demonstration" theme="secondary" path="/#contact" />
            </div>
        </AboutItem>
    )
}
